<template>
  <div class="content">
    <div class="table">
      <div class="first_line">
        <div class="text_user">待审核用户</div>
        <div class="current_user">
          （当前用户审批邮箱为：
          <a>{{email}}</a>）
        </div>
        <el-button class="btnsearch mgright" @click="dialogVisible = true">修改</el-button>
        <el-input placeholder="请输入内容" v-model="inputSearch" class="input-with-select"></el-input>
        <el-button class="btnsearch" icon="el-icon-search" @click="loadUser">搜索</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{
          background: 'seagreen',
          color: '#fff',
          height: '35px',
          padding: '6px 0',
        }"
        style="width: 100%"
      >
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="realname" label="真实姓名"></el-table-column>
        <!-- <el-table-column label="审批状态">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" class="ysh" v-if="scope.row.state == 1"
                >已审核</el-tag
              >
              <el-tag size="medium" class="wsh" v-if="scope.row.state == 0"
                >未审核</el-tag
              >
            </div>
          </template>
        </el-table-column>-->

        <el-table-column prop="reday" label="剩余天数"></el-table-column>
        <el-table-column prop="email" label="注册邮箱"></el-table-column>
        <el-table-column prop="telephone" label="联系电话"></el-table-column>
        <el-table-column prop="direction" label="研究方向"></el-table-column>
        <el-table-column prop="college" label="所属院校"></el-table-column>
        <!-- <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              class="btnsh"
              size="mini"
              v-if="scope.row.state == 0"
              @click="handleEdit(scope.$index, scope.row)"
              >审核</el-button
            >
            <el-button
              class="btnsh"
              size="mini"
              disabled
              v-if="scope.row.state == 1"
              >审核</el-button
            >
          </template>
        </el-table-column>-->
      </el-table>

      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="num"
          layout="sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="修改用户审批邮箱" :visible.sync="dialogVisible" width="30%" top="220px">
      <el-input size="small" v-model="inputemail" placeholder="请输入邮箱..."></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          style="background: seagreen; color: #fff"
          size="small"
          type="primary"
          @click="updateEmail"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios"
export default {
  data() {
    return {
      //表格数据
      tableData: [],
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      num: 20,
      page: 1,
      total: 0,
      inputSearch: "",
      inputemail: "",
      dialogVisible: false,
      email: ''
    }
  },
  created() {
    let token = localStorage.getItem("authorization")
    if (token == "" || token == null) {
      this.$alert("Login expired, please log in again", "Notice", {
        confirmButtonText: 'Confirm',
        callback: (action) => {
          that.$router.push("/login")
        },
      })
      return false
    }
    let email = localStorage.getItem("email",'')
    if (email != "" && email != null && email != 'null') {
      this.email = email
    }
    this.loadUser()
  },
  methods: {
    updateEmail() {
      if (this.inputemail == "" || this.inputemail == null) {
        this.$alert("请输入邮箱！", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => { },
        })
        return false
      }
      let reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/
      if (!reg.test(this.inputemail)) {
        this.$alert("请输入正确的邮箱地址！", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => { },
        })
        return false
      }
      let userId = localStorage.getItem("userId")
      let that = this
      let role = localStorage.getItem('isa')
      let token = localStorage.getItem("authorization")
      axios
        .post("/bena/server/gooal/user/update", {
          userId: userId,
          email: this.inputemail
        }, {
          headers: { Authorization: token, role: role },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            //that.tableData = response.data.result;
            that.$alert("修改成功！", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                localStorage.setItem("email", response.data.result.email)
                that.email = response.data.result.email
                that.$router.go(0)
              },
            })
          } else {
            that.$alert("修改失败！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          that.$message.error("失败!")
          //console.log(error);
        })

    },
    loadUser() {
      let that = this
      let role = localStorage.getItem('isa')
      let token = localStorage.getItem("authorization")
      if (token == "" || token == null) {
        this.$alert("Login expired, please log in again", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => {
            that.$router.push("/login")
          },
        })
        return false
      }
      axios
        .get("/bena/server/gooal/user/like/page?num=" + this.num + "&page=" + this.page +"&name=" + this.inputSearch, {
          headers: { Authorization: token, role: role },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.tableData = response.data.result.list
            that.total = response.data.result.total
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          that.$message.error("失败!")
          //console.log(error);
        })
    },
    handleEdit(index, row) {
      //console.log(index, row);
      let that = this
      let token = localStorage.getItem("authorization")
      let role = localStorage.getItem('isa')
      axios
        .get("/bena/server/gooal/user/updatestate?user_id=" + row.userId, {
          headers: { Authorization: token, role: role },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.$alert("审核成功！", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                that.loadUser()
              },
            })
          } else {
            that.$alert("审核失败！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          that.$message.error("失败!")
          //console.log(error);
        })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.num = val
      this.loadUser()
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val
      this.loadUser()
    },
  },
};
</script>

<style scoped>
.el-tag.el-tag--medium.el-tag--light.wsh {
  background: rgb(182, 218, 198);
  color: rgb(117, 185, 147);
}
.btnsh {
  border: seagreen 1px solid;
  color: seagreen;
}
.btnsh:hover {
  background: seagreen;
  color: #fff;
  border: none;
}
.input-with-select.el-input >>> .el-input__inner {
  border-radius: 0;
  height: 35px;
}
.block {
  float: right;
  margin-top: 50px;
}
.content {
  /* background: #eee; */
  width: 1200px;
  min-height: 570px;
  margin: 0 auto;
}
.content .table {
  width: 1140px;
  overflow: auto;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 2px #ccc;
  background: #fff;
  padding: 30px;
  margin: 20px 0 20px 0;
}
.first_line {
  display: flex;
  margin-bottom: 30px;
}
.text_user {
  font-size: 20px;
  font-weight: 600;
  line-height: 35px;
}
.current_user {
  margin-left: 20px;
  line-height: 35px;
  font-size: 14px;
}
.input-with-select {
  width: 200px;
}
.el_change {
  border: 5px solid;
  margin: 0 100px 0 30px;
  background-color: seagreen;
  font-weight: normal;
}
.btnsearch {
  height: 35px;
  color: #fff;
  background: seagreen;
  padding: 10px 20px;
  font-size: 14px;
  margin-left: 10px;
}
.btnsearch:hover {
  background: #fff;
  border: 1px solid seagreen;
  color: seagreen;
}
.mgright {
  margin-right: 50px;
}
.el-pager li.active {
  color: seagreen;
  cursor: default;
}
</style>
